import React from 'react';

import { LoadingPanel } from '../common/LoadingPanel';

import { TestID } from '../../testID';

import './ConnectMessages.scss';

export const HibernatedMessage: React.FC = () => (
  <LoadingPanel
    loadingMessage={
      <div data-testid={TestID.ConnectToSubscriptionHibernatedMessage}>
        <p className="connect-message-body">
          <div>Subscription Hibernated Due to Idleness!</div>
          <div>Provisioning in progress...</div>
          <div>This may take a few minutes.</div>
        </p>
      </div>
    }
    size="medium"
  />
);
